import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ConfigService } from './config.service';
import { PageViewEvent } from '../super-admin/governance/models/governance.models';

@Injectable({ providedIn: 'root' })
export class PageViewTrackerService implements OnDestroy {
  private buffer: PageViewEvent[] = [];
  private prev: string | null = null;
  private timer: any = null;
  private sub: Subscription | null = null;
  private readonly url: string;

  constructor(private router: Router, private http: HttpClient, config: ConfigService, private zone: NgZone) {
    this.url = `${config._url}v1/usage/page-views`;
  }

  start(): void {
    if (this.sub) return;
    this.sub = this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      const url = (e as NavigationEnd).urlAfterRedirects || (e as NavigationEnd).url;
      const path = this.stripQuery(url);
      this.buffer.push({ routePath: path, pageTitle: document.title, referrerPath: this.prev });
      this.prev = path;
      if (this.buffer.length >= 50) this.flush();
    });
    this.zone.runOutsideAngular(() => { this.timer = setInterval(() => this.flush(), 15000); });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') this.flush(true); });
    window.addEventListener('beforeunload', () => this.flush(true));
  }

  private stripQuery(u: string): string {
    if (!u) return '/';
    const i = u.search(/[?#]/); return i >= 0 ? (u.substring(0, i) || '/') : u;
  }

  private flush(useBeacon = false): void {
    if (this.buffer.length === 0) return;
    const events = this.buffer.splice(0, this.buffer.length);
    if (useBeacon && navigator.sendBeacon) {
      try { navigator.sendBeacon(this.url, new Blob([JSON.stringify({ events })], { type: 'application/json' })); return; } catch { /* fall through */ }
    }
    this.http.post(this.url, { events }).subscribe({ next: () => {}, error: () => {} });
  }

  ngOnDestroy(): void { if (this.timer) clearInterval(this.timer); this.sub?.unsubscribe(); }
}
